import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";

const WalletIcon = (props) => (
  <Svg
    width={33}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M16.351 2.744a2.006 2.006 0 0 1 1.357-.74 2.016 2.016 0 0 1 1.483.44l6.55 5.328a1.999 1.999 0 0 1 .502 2.49A6.048 6.048 0 0 0 24.476 10h-.602l.598-.68-3.45-2.806-2.845 3.488h-2.589l3.878-4.752-1.547-1.258L13.104 10h-2.57l5.817-7.256ZM21.464 20a1.006 1.006 0 0 0-1.004 1 .998.998 0 0 0 1.004 1h2.008a.998.998 0 1 0 0-2h-2.008ZM6.403 11a.998.998 0 0 1 1.004-1h1.12l1.597-2H7.407c-.799 0-1.565.316-2.13.879a2.994 2.994 0 0 0-.882 2.12v12a4.99 4.99 0 0 0 1.47 3.537A5.03 5.03 0 0 0 9.415 28h15.061a4.025 4.025 0 0 0 2.84-1.172A3.992 3.992 0 0 0 28.492 24v-8c0-1.06-.423-2.078-1.176-2.829A4.025 4.025 0 0 0 24.476 12H7.406a.998.998 0 0 1-1.004-1Zm0 12v-9.17c.313.11.652.17 1.004.17h17.069c.533 0 1.043.21 1.42.586.377.375.588.883.588 1.414v8c0 .53-.211 1.04-.588 1.414a2.013 2.013 0 0 1-1.42.586H9.416a3.018 3.018 0 0 1-2.13-.879A2.994 2.994 0 0 1 6.402 23Z"
      fill="#3B869A"
    />
  </Svg>
);

export default WalletIcon;
